var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0681 1.87786C15.8817 1.1374 15.3441 0.557252 14.6559 0.358778C13.4086 -1.59249e-07 8.40503 0 8.40503 0C8.40503 0 3.40145 -1.59249e-07 2.15413 0.358778C1.46596 0.557252 0.921158 1.1374 0.741947 1.87786C0.405029 3.21374 0.405029 6 0.405029 6C0.405029 6 0.405029 8.78626 0.741947 10.1221C0.928327 10.8626 1.46596 11.4427 2.15413 11.6412C3.40145 12 8.40503 12 8.40503 12C8.40503 12 13.4086 12 14.6559 11.6412C15.3441 11.4427 15.8889 10.8626 16.0681 10.1221C16.405 8.78626 16.405 6 16.405 6C16.405 6 16.405 3.21374 16.0681 1.87786ZM6.77062 8.53435V3.46565L10.9498 6L6.77062 8.53435Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.98f6b3dc56f9c647d11aeb83ec9c1157.svg";
export { ForwardRef as ReactComponent };